import { useQuery } from "@tanstack/react-query";
import type { BundleRecommendationResponse } from "../types/viewmodel";
import { getRecommendations } from "../services/recommendationsService";

export const RECOMMENDATIONS_QUERY_KEY = "recommendations";

interface UseRecommendationsOptions {
	bundleId: string;
	enabled?: boolean;
}

export function useRecommendations({
	bundleId,
	enabled = true,
}: UseRecommendationsOptions) {
	return useQuery<BundleRecommendationResponse, Error>({
		queryKey: [RECOMMENDATIONS_QUERY_KEY, bundleId],
		queryFn: () => getRecommendations(bundleId),
		enabled: enabled && !!bundleId,
		staleTime: 1000 * 60 * 5, // 5 minutes
		gcTime: 1000 * 60 * 10, // 10 minutes
		retry: 1,
	});
}
